<template>
  <NuxtLayout>
    <NuxtPage />
    <!-- SEO Noscript Fallback Navigation -->
    <noscript>
      <div style="padding: 20px; background: #fff; text-align: center;">
        <p><strong>Site Navigation:</strong></p>
        <ul style="list-style: none; padding: 0;">
          <li><a href="/">Home</a></li>
          <li><a href="/shop">All Products & Equipment</a></li>
          <li><a href="/knowledge-base">Safety Knowledge Base</a></li>
          <li><a href="/contact">Contact Us</a></li>
          <li><a href="/about">About Alarm Supplies</a></li>
        </ul>
      </div>
    </noscript>
  </NuxtLayout>
</template>

<script setup lang="ts">
useHead({
  htmlAttrs: {
    lang: 'en-QA'
  },
  link: [
    {
      rel: 'alternate',
      hreflang: 'en-QA',
      href: 'https://alarmsupplies.qa'
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: 'https://alarmsupplies.qa'
    }
  ]
})

useSchemaOrg([
  defineLocalBusiness({
    name: 'Adam Technical Services - Alarm Supplies',
    image: 'https://alarmsupplies.qa/images/logo.png',
    url: 'https://alarmsupplies.qa',
    telephone: '+974 4140 0922',
    priceRange: '$$',
    address: {
      streetAddress: '6th Floor Suhaim Tower, Office No: 604, C-Ring Road',
      addressLocality: 'Doha',
      addressCountry: 'QA'
    },
    geo: {
      latitude: 25.2635,
      longitude: 51.5204
    },
    openingHoursSpecification: [
      {
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Sunday'],
        opens: '08:00',
        closes: '18:00'
      }
    ],
    sameAs: [
      'https://www.facebook.com/p/Adam-Qa-61567648601204/'
    ]
  }),
  // ✅ Phase 4: WebSite schema with SearchAction — enables Google Sitelinks Searchbox
  // and tells AI search engines (Perplexity, SearchGPT) about our product search
  {
    '@type': 'WebSite',
    '@id': 'https://alarmsupplies.qa/#website',
    url: 'https://alarmsupplies.qa',
    name: 'Alarm Supplies Qatar — Fire Protection Equipment',
    description: 'Qatar\'s leading supplier of QCDD-certified fire protection equipment. Fire alarms, smoke detectors, extinguishers, sprinkler systems in Doha.',
    inLanguage: 'en-QA',
    publisher: {
      '@type': 'Organization',
      '@id': 'https://alarmsupplies.qa/#organization',
      name: 'Adam Technical Services - Alarm Supplies',
      logo: {
        '@type': 'ImageObject',
        url: 'https://alarmsupplies.qa/images/logo.png'
      }
    },
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://alarmsupplies.qa/shop?q={search_term_string}'
      },
      'query-input': 'required name=search_term_string'
    }
  }
])
</script>

<style>
.page-enter-active,
.page-leave-active {
  transition: all 0.3s ease-out;
}
.page-enter-from {
  opacity: 0;
  transform: translateY(10px);
}
.page-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
